// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDvlVE7nAyemx4LUS4ZY7Dc5N-OEZ0I8Fg",
  authDomain: "connek-1bbe4.firebaseapp.com",
  projectId: "connek-1bbe4",
  storageBucket: "connek-1bbe4.appspot.com",
  messagingSenderId: "483722458724",
  appId: "1:483722458724:web:8cb7b2f108a8d07c269171",
  measurementId: "G-HRFLSNGS97"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth();
export const storage = getStorage();
export const db = getFirestore();